<template>
    <div class="standard-content">
        <div class="standard-title">
            <i class="mtdicon-info-circle-o"></i>规范说明
        </div>
        <ol class="standard-info">
            <li
                v-for="item in standardDescriptionList"
                :key="item.key"
            >
                <span>{{ item.notice }}</span>
                <mc-button
                    v-if="item.imgs.length"
                    type="text"
                    class="show-btn"
                    @click="showExampleImg(item.imgs)"
                >
                    查看示例
                </mc-button>
            </li>
        </ol>
        <mc-modal
            v-model="show"
            title="示例图片"
            width="45%"
            class="img-dialog"
        >
            <div
                class="container"
            >
                <mc-image
                    v-for="item in exampleImgList"
                    :key="item.imgKey"
                    :style="item.imgStyle"
                    :src="item.url"
                    :preview-url-list="[item.url]"
                    class="imgs"
                />
            </div>
            <div
                slot="footer"
                class="footer-btn"
            >
                <mc-button
                    type="primary"
                    @click="close"
                >
                    关闭
                </mc-button>
            </div>
        </mc-modal>
    </div>
</template>
<script>

export default {
    name: 'QualificationStandard',
    props: {
        standardDescriptionList: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            show: false,
            exampleImgList: [],
        };
    },
    methods: {
        close() {
            this.show = false;
        },
        showExampleImg(imgs) {
            this.exampleImgList = imgs || [];
            this.show = true;
        },
    },
};
</script>
<style scoped lang="scss">
.standard-content {
    background-color: rgb(230, 246, 238);
    border-radius: 5px;
    margin-bottom: 10px;
    padding: 5px;
    line-height: 22px;
    .standard-title {
        font-size: 14px;
        font-weight: bold;
        padding: 5px 0;
    }
    .show-btn {
        padding: 0;
        /deep/ .mtd-btn-text {
            color: royalblue;
        }
        /deep/ .mtd-btn {
            height: 22px;
        }
    }
    .standard-info {
        padding-inline-start: 20px;
        margin: 0;
    }
}
.img-dialog {
    display: flex;
    justify-content: center;
    align-items: center;
    .container {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        overflow: auto;
        .imgs {
            margin: 20px 10px;
        }
    }
    .footer-btn {
        display: flex;
        justify-content: center;
    }
    /* 保证预览图片层叠在弹窗上方 */
    /deep/ .mtd-modal-mask {
        z-index: 1999 !important;
    }
    /deep/ .mtd-modal-center {
        z-index: 1999 !important;
    }
    /deep/ .mtd-modal-wrapper {
        z-index: 1999 !important;
    }
}
</style>
